<!-- CFRC Update Component Template -->

<div class="alert alert-primary flex-between" *ngIf="action !== 'update'">
  <div>Apply discount for all irrespective of region and usage type</div>
  <label class="switch">
    <input
      type="checkbox"
      [(ngModel)]="selectAll"
      (change)="onSelectAllChange()"
    />
    <span class="slider round"></span>
  </label>
</div>

<!-- Original Form (shown when selectAll is OFF) -->
<div class="alarm_body" style="padding: 1px 25px 5px 25px">
  <div [ngStyle]="{ display: !selectAll ? 'block' : 'none' }">
    <!-- ── Region (ADD mode) ─────────────────────────────────────── -->
    <div class="row" *ngIf="action !== 'update'">
      <div class="flex-between">
        <label>Region</label>
        <div class="flex-start filters">
          <div class="flex-start">
            <input
              type="checkbox"
              id="cfrc_select_all_regions"
              (change)="selectAllRegions($event)"
            />
            <label for="cfrc_select_all_regions">Select All</label>
          </div>
          <div class="flex-start" *ngIf="regions_reg && regions_reg.length > 0">
            <!-- <span class="nav-link" (click)="selectFiltertedRegions($event)">Select Filtered</span> -->
          </div>
        </div>
      </div>
      <select
        class="form-control"
        id="cfrc_regions_reg"
        (change)="fetchPlatformsTypes()"
        [(ngModel)]="ri.regionn"
        data-live-search="true"
        multiple
        required
      >
        <option *ngFor="let type of regions_reg" [value]="type">
          {{ type }}
        </option>
      </select>
    </div>

    <!-- ── Region (UPDATE mode) ──────────────────────────────────── -->
    <div class="row" *ngIf="action === 'update'">
      <label>Region</label>
      <select
        class="form-control"
        id="cfrc_regions_reg_update"
        [(ngModel)]="ri.regionn"
        readonly
      >
        <option [value]="ri.regionn">{{ ri.regionn }}</option>
      </select>
    </div>

    <!-- ── Usage Type (ADD mode) ─────────────────────────────────── -->
    <div class="row" *ngIf="action !== 'update'">
      <div class="flex-between">
        <label>Usage Type</label>
        <div class="flex-start filters">
          <div class="flex-start">
            <input
              type="checkbox"
              id="cfrc_select_all_usage_types"
              (change)="selectAllUsageTypes($event)"
            />
            <label for="cfrc_select_all_usage_types">Select All</label>
          </div>
          <div class="flex-start" *ngIf="usageType && usageType.length > 0">
            <!-- <span class="nav-link" (click)="selectFiltertedUsageTypes($event)">Select Filtered</span> -->
          </div>
        </div>
      </div>
      <select
        class="form-control"
        id="cfrc_platformsList"
        (change)="fetchRICost()"
        [(ngModel)]="ri.usageType"
        data-live-search="true"
        multiple
        required
      >
        <option *ngFor="let platform of usageType" [value]="platform">
          {{ getDisplayName(platform) }}
        </option>
      </select>
    </div>

    <!-- ── Usage Type (UPDATE mode) ──────────────────────────────── -->
    <div class="row" *ngIf="action === 'update'">
      <label>Usage Type</label>
      <select
        class="form-control"
        id="cfrc_platformsList_update"
        [(ngModel)]="ri.usageType"
        readonly
      >
        <option [value]="ri.usageType">
          {{ getDisplayName(ri.usageType) }}
        </option>
      </select>
    </div>

    <!-- ── Unit (only when single region + single usageType selected) ── -->
    <div
      class="row"
      *ngIf="
        !selectAll &&
        ri?.regionn &&
        ri.regionn.length <= 1 &&
        ri?.usageType &&
        ri.usageType !== 'all' &&
        ri.usageType !== 'alls' &&
        ri.usageType.length <= 1
      "
    >
      <label>Unit</label>
      <input
        type="text"
        style="padding-left: 12px"
        class="form-control"
        [(ngModel)]="ri.unit"
        readonly
      />
    </div>

    <!-- ── Price Per Unit ────────────────────────────────────────── -->
    <div
      class="row"
      *ngIf="
        !selectAll &&
        ri?.regionn &&
        ri.regionn.length <= 1 &&
        ri?.usageType &&
        ri.usageType !== 'all' &&
        ri.usageType !== 'alls' &&
        ri.usageType.length <= 1
      "
    >
      <label>Price Per Unit</label>
      <input
        type="text"
        style="padding-left: 12px"
        class="form-control"
        [(ngModel)]="ri.ppu"
        readonly
      />
    </div>

    <!-- ── Discount Type (ADD mode) ──────────────────────────────── -->
    <div class="row" *ngIf="action !== 'update'">
      <label>Discount Type</label>
      <div class="form-check" style="padding-left: 30px">
        <input
          class="form-check-input"
          type="radio"
          name="cfrc_discountType"
          id="cfrc_percentage"
          value="percentage"
          [(ngModel)]="ri.discountType"
          checked
        />
        <label class="form-check-label" for="cfrc_percentage">Percentage</label>
      </div>
      <div class="form-check" style="padding-left: 30px">
        <input
          class="form-check-input"
          type="radio"
          name="cfrc_discountType"
          id="cfrc_value"
          value="value"
          [(ngModel)]="ri.discountType"
        />
        <label class="form-check-label" for="cfrc_value">Value</label>
      </div>
    </div>

    <!-- ── Discount input (ADD mode) ────────────────────────────── -->
    <div class="row" *ngIf="action !== 'update'">
      <label>{{
        ri.discountType === "value" && !selectAll
          ? "Discount Value:"
          : "Discount Percentage:"
      }}</label>
      <div class="percentage-input-group">
        <input
          type="text"
          class="form-control"
          [(ngModel)]="ri.discountPercentage"
          required
          (keydown)="validateNumericInput($event)"
        />
        <span class="input-group-text" *ngIf="ri.discountType !== 'value'"
          >%</span
        >
      </div>
    </div>

    <!-- ── Discount input (UPDATE mode) ─────────────────────────── -->
    <div class="row" *ngIf="action === 'update'">
      <label>{{
        ri.discountType === "value" && !selectAll
          ? "Discount Value:"
          : "Discount Percentage:"
      }}</label>
      <div class="percentage-input-group">
        <input type="text" class="form-control" [(ngModel)]="disc" required />
        <span
          class="input-group-text"
          *ngIf="ri.discountType === 'percentage' && !selectAll"
          >%</span
        >
      </div>
    </div>

    <!-- ── Period (single row, disabled in update mode) ──────────────── -->
    <div class="row">
      <label>Period:</label>
      <input
        type="text"
        id="cfrc_dataRangePicker"
        [(ngModel)]="dateRange"
        class="form-control"
        style="width: 300px; padding-left: 12px"
        placeholder="Select date"
        [attr.disabled]="action === 'update' ? true : null"
      />
    </div>
  </div>
  <!-- /!selectAll block -->
</div>
<!-- /alarm_body -->

<!-- ── Alternative Form (Select All ON) ─────────────────────────────────── -->
<div
  class="new_form"
  [ngStyle]="{ display: selectAll ? 'block' : 'none' }"
  style="padding: 1px 25px 5px 25px"
>
  <!-- Usage Type (always "All" when selectAll) -->
  <div class="row">
    <label>Usage Type</label>
    <input
      style="padding-right: 12px"
      type="text"
      class="form-control"
      [ngModel]="selectAll ? 'All' : ri.usageType"
      [attr.disabled]="selectAll ? true : null"
    />
  </div>

  <!-- Discount Type (always Percentage, disabled) -->
  <div class="row">
    <label>Discount Type</label>
    <div class="form-check" style="padding-left: 30px">
      <input
        class="form-check-input"
        type="radio"
        name="cfrc_newDiscountType"
        id="cfrc_newPercentage"
        value="percentage"
        checked
        disabled
      />
      <label class="form-check-label" for="cfrc_newPercentage"
        >Percentage</label
      >
    </div>
    <div class="form-check" style="padding-left: 30px">
      <input
        class="form-check-input"
        type="radio"
        name="cfrc_newDiscountType"
        id="cfrc_newValue"
        value="value"
        disabled
      />
      <label class="form-check-label" for="cfrc_newValue">Value</label>
    </div>
  </div>

  <!-- Discount Percentage (ADD mode) -->
  <div class="row" *ngIf="action !== 'update'">
    <label>Discount Percentage:</label>
    <div class="percentage-input-group">
      <input
        type="text"
        class="form-control"
        [(ngModel)]="ri.discountPercentage"
        required
        (keydown)="validateNumericInput($event)"
      />
      <span class="input-group-text" *ngIf="ri.discountType !== 'value'"
        >%</span
      >
    </div>
  </div>

  <!-- Discount Percentage (UPDATE mode, usageType === 'all') -->
  <div class="row" *ngIf="ri.usageType === 'all' && action === 'update'">
    <label>Discount Percentage:</label>
    <div class="percentage-input-group">
      <input type="text" class="form-control" [(ngModel)]="disc" required />
      <span class="input-group-text" *ngIf="ri.discountType !== 'value'"
        >%</span
      >
    </div>
  </div>
</div>
<!-- /new_form -->

<!-- ── Child Status Popup ────────────────────────────────────────────────── -->
<div
  *ngIf="childStatusList && childStatusList.length > 0"
  class="child-status-popup"
>
  <div class="popup-header">
    <h3>Child Account Status</h3>
    <button class="close-btn" (click)="statusclose()">&times;</button>
  </div>
  <div class="popup-body">
    <div *ngFor="let child of childStatusList" class="status-row">
      <span>{{ child.id }}</span>
      <span class="status-icon">
        <ng-container [ngSwitch]="child.status">
          <i
            *ngSwitchCase="'processing'"
            class="fa fa-spinner fa-spin text-primary"
          ></i>
          <i
            *ngSwitchCase="'success'"
            class="fa fa-check-circle text-success"
          ></i>
          <i *ngSwitchCase="'fail'" class="fa fa-times-circle text-danger"></i>
          <span *ngSwitchDefault>⏳</span>
        </ng-container>
      </span>
    </div>
  </div>
</div>

<style>
  .alarm_screen label {
    padding: 0 !important;
  }
</style>